import React, { Component } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import Spinner from "../../Spinner";

class LocationRegion extends Component {
  state = { selectedRegion: "" };

  handleSelect = (val) => {
    this.setState({ selectedRegion: val });
  };

  customFilter = (option, searchText) => {
    if (option.data.name.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };

  render() {
    return (
      <div>
        {this.props.regions.length > 0 ? (
          <div className="row m-0">
            <div className="col-md-12 col-sm-12 pb-5 pl-0 mb_p_0">
              <div className="Header-Content overflow-hidden position-relative lmrdrpdwn">
                <h5 className="form_label">Regions</h5>
                {this.props.user.role === "Admin" ? (
                  <Link to="/masters/region/create" className="addRegionBtn">
                    Add Region
                  </Link>
                ) : (
                  ""
                )}
              </div>
              <div className="">
                <Select
                  onChange={this.handleSelect}
                  getOptionLabel={(option) => `${option.name} `}
                  getOptionValue={(option) => `${option.id}`}
                  isOptionSelected={(option) => {
                    return this.state.selectedRegion.id === option.id
                      ? true
                      : false;
                  }}
                  options={this.props.regions}
                  isSearchable={true}
                  filterOption={this.customFilter}
                  onInputChange={this.handleInputChange}
                  noOptionsMessage={() => null}
                  placeholder={"Search Region"}
                  autoFocus={true}
                  menuIsOpen={this.state.menuOpen}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,

                      primary25: "#ffa552",
                      primary50: "#fabc82",
                      primary: "#fcb26d",
                    },
                  })}
                />
              </div>
            </div>

            <div className="col-md-12 col-sm-12 pl-0 locationTableDiv mb_p_0">
              {this.state.selectedRegion !== "" ? (
                <div className="">
                  <table className="table table-hover tableStyle2">
                    <thead>
                      <tr>
                        <td>Region</td>
                        <td>Short Name</td>
                        <td>Is Active</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td data-th="Region">
                          {this.state.selectedRegion.name}
                        </td>
                        <td data-th="Short Name">
                          {this.state.selectedRegion.shortName}
                        </td>
                        <td data-th="Is Active">
                          {this.state.selectedRegion.activeFlag === "Y"
                            ? "True"
                            : "False"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {this.props.user.role === "Admin" ? (
                    <div className="row m-0">
                      <div className="col p-0">
                        <Link
                          to={`/masters/region/${this.state.selectedRegion.id}/state/create`}
                          className="linkBtn1"
                        >
                          Add State
                        </Link>

                        <Link
                          to={`/masters/region/Edit/${this.state.selectedRegion.id}`}
                          className="linkBtn1"
                        >
                          Modify
                        </Link>
                      </div>
                    </div>
                  ) : (
                    " "
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    );
  }
}

export default LocationRegion;
